import axios from 'axios'
axios.defaults.headers['Content-Type'] = 'application/x-www-form-urlencoded; charset=UTF-8'
 // axios中请求配置有baseURL选项，表示请求URL公共部分
axios.defaults.baseURL = 'https://jcd.bavlo.com/manage/'
// 创建axios实例
const service = axios.create({
  // 超时
  timeout: 10000
})

// 响应拦截器
service.interceptors.response.use(res => {
    // return res.data
    return Promise.resolve(res.data)
  },
  error => {
    console.log('err' + error)
    let {
      message
    } = error;
    if (message == "Network Error") {
      message = "后端接口连接异常";
    } else if (message.includes("timeout")) {
      message = "系统接口请求超时";
    } else if (message.includes("Request failed with status code")) {
      message = "系统接口" + message.substr(message.length - 3) + "异常";
    }
    return Promise.reject(error)
  }
)

export default service
